import { render, staticRenderFns } from "./HonorList.vue?vue&type=template&id=56c7f2ac"
import script from "./HonorList.vue?vue&type=script&lang=ts"
export * from "./HonorList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports